import { useQuery } from "@tanstack/react-query";
import { ExternalLink } from "lucide-react";
import { orpc } from "@/frontend/orpc-client";

/**
 * Small "Can't find your facility? Request it" affordance surfaced under
 * the patient portal picker and dashboard EHR picker. Opens the URL from
 * `FACILITY_REQUEST_FORM_URL` (a Google Form) in a new tab; renders
 * nothing while the runtime config loads and when the env var is unset,
 * so environments without a form configured don't ship a broken link.
 */
export function RequestFacilityLink({ className }: { className?: string }) {
  const { data } = useQuery(
    orpc.runtimeConfig.get.queryOptions({ input: {}, staleTime: Infinity }),
  );
  const url = data?.facilityRequestFormUrl;
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={
        "inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground underline underline-offset-2 " +
        (className ?? "")
      }
    >
      Can&apos;t find your facility? Request it
      <ExternalLink className="w-3 h-3" />
    </a>
  );
}
